import { gql } from 'apollo-boost';

export const deleteQuicksightDashboard = gql`
mutation deleteQuicksightDashboard (
  $id: Int!,
) {
deleteQuicksightDashboard (
  id: $id,
) {
    success
    id
  }
}
`;
